import React, { useEffect, useState } from 'react';
import { Container, Table, Button } from 'react-bootstrap';
import axios from 'axios';
import * as XLSX from 'xlsx';

const GestionProductos = () => {
    // const obtenerVisitasURL = "https://demo.edgarleal.es/cerbero/api/leer_visitas.php";
    // const [productos, setProductos] = useState([]);
    // const [showModal, setShowModal] = useState(false);
    // const [productoSeleccionado, setProductoSeleccionado] = useState(null);
    // const [empresa_idEmpresa, setEmpresaIdEmpresa] = useState(null);

    // useEffect(() => {
    //     // Obtener empresa_idEmpresa del localStorage al cargar el componente
    //     const userData = JSON.parse(localStorage.getItem('usuario'));
    //     if (userData && userData.empresa_idEmpresa) {
    //         setEmpresaIdEmpresa(userData.empresa_idEmpresa);
    //     }
    // }, []);

    // useEffect(() => {
    //     // Llamar a la API solo cuando se haya obtenido empresa_idEmpresa
    //     if (empresa_idEmpresa) {
    //         obtenerDatos();
    //     }
    // }, [empresa_idEmpresa]);

    // // Función para obtener los datos de la API
    // const obtenerDatos = async () => {
    //     try {
    //         // Verificar que empresa_idEmpresa tenga un valor válido
    //         if (!empresa_idEmpresa) {
    //             console.error('empresa_idEmpresa no está definida.');
    //             return;
    //         }

    //         console.log('Enviando empresa_idEmpresa:', empresa_idEmpresa); // Verificar el valor antes de la solicitud
    //         const response = await axios.post(obtenerVisitasURL, {
    //             empresa_idEmpresa: empresa_idEmpresa.toString() // Convertir a cadena
    //         });
    //         console.log('Datos recibidos:', response.data); // Verificar los datos recibidos

    //         setProductos(response.data);
    //     } catch (error) {
    //         console.error('Error al obtener los datos de la API:', error);
    //     }
    // };

    // // Función para manejar la exportación a Excel
    // const exportarExcel = () => {
    //     const ws = XLSX.utils.json_to_sheet(productos);
    //     const wb = XLSX.utils.book_new();
    //     XLSX.utils.book_append_sheet(wb, ws, 'Productos');
    //     XLSX.writeFile(wb, 'productos.xlsx');
    // };

    // // Función para mostrar el modal con detalles del producto
    // const handleShowModal = (producto) => {
    //     setProductoSeleccionado(producto);
    //     setShowModal(true);
    // };

    // // Función para cerrar el modal
    // const handleCloseModal = () => {
    //     setShowModal(false);
    //     setProductoSeleccionado(null);
    // };

    // return (
    //     <Container maxWidth="sm">
    //         <h2 className="my-4 text-center" style={{ fontWeight: 'bold', color: '#007bff' }}>Gestión de Visitas</h2>
    //         <div className="table-responsive">
    //             <Button variant="success" className="mb-3" onClick={exportarExcel}>
    //                 Exportar a Excel
    //             </Button>
    //             <Table striped bordered hover size="sm" className="table-sm">
    //                 <thead>
    //                     <tr>
    //                         <th scope="col">Nombre</th>
    //                         <th scope="col">RUT</th>
    //                         <th scope="col">Fecha</th>
    //                         <th scope="col">Motivo</th>
    //                         <th scope="col">Destino</th>
    //                         <th scope="col">Registrador</th>
    //                         <th scope="col">Acciones</th>
    //                     </tr>
    //                 </thead>
    //                 <tbody>
    //                     {productos.length > 0 ? (
    //                         productos.map((producto, index) => (
    //                             <tr key={index}>
    //                                 <td>{producto.nombre}</td>
    //                                 <td>{producto.rut}</td>
    //                                 <td>{producto.fecha}</td>
    //                                 <td>{producto.motivo}</td>
    //                                 <td>{producto.destino}</td>
    //                                 <td>{producto.registrador}</td>
    //                                 <td style={{ display: 'flex', gap: '10px' }}>
    //                                     <Button variant="primary" size="sm" onClick={() => handleShowModal(producto)}>
    //                                         Ver
    //                                     </Button>
    //                                 </td>
    //                             </tr>
    //                         ))
    //                     ) : (
    //                         <tr>
    //                             <td colSpan="7" className="text-center">No hay visitas disponibles</td>
    //                         </tr>
    //                     )}
    //                 </tbody>
    //             </Table>
    //         </div>
    //         {/* Modal de detalles del producto (si fuera necesario) */}
    //     </Container>
    // );
};

export default GestionProductos;
